import { configureStore } from "@reduxjs/toolkit";
import kalinkaReducer from './kalinkaSlice';

const store = configureStore({
    reducer: {
        kalinka: kalinkaReducer
    },
})
window.store = store;
export default store;